import { Component, OnInit } from '@angular/core';
import { DataService } from '../../shared/dataservice.service';

@Component({
  selector: 'app-kpi-excel',
  templateUrl: './kpi-excel.component.html',
  styleUrls: ['./kpi-excel.component.css']
})
export class KpiExcelComponent implements OnInit {
  constructor(private _dataService: DataService) { }
  isLoading:boolean = false;
  ngOnInit() {
    this._dataService.currPageName = 'TPT + Downloads';
    
  }
  downloadExcelTPT(isArchive:boolean) {
    if(isArchive == false)
    this._dataService.downloadFile('tptAuto');
  }
  downloadExcelSAP(isArchive:boolean) {
    if(isArchive == false)
    this._dataService.downloadFile('sap');
  }
  downloadExcelSAP2(isArchive:boolean) {
    if(isArchive == false)
    this._dataService.downloadFile('sap2');
  }
}
